import type { UILabeledAggregation } from '../services/SiteReportingService/types';

export interface OrderToDeliverReportSummaryDetail {
  value: number;
  key: string;
  id: string;
  label: string;
  units: string;
}

export const orderToDeliverReportSummary = (data: UILabeledAggregation[]) => {
  const units = data[0] ? data[0].units : '';
  const pctAvgDaySum = data.reduce((accum: Record<string, number>, current) => {
    if (!accum[current.label]) {
      accum[current.label] = 0;
    }
    accum[current.label] += current.value;
    return accum;
  }, {});
  const daysCount = data.reduce((accum: Record<string, number>, current) => {
    if (!accum[current.label]) {
      accum[current.label] = 0;
    }
    accum[current.label] += 1;
    return accum;
  }, {});
  const summary: Record<string, number> = {};
  for (const key in daysCount) {
    if (key) {
      summary[key] = Math.ceil(pctAvgDaySum[key] / daysCount[key]);
    }
  }
  return Object.keys(summary).map<OrderToDeliverReportSummaryDetail>((key) => {
    const detail: OrderToDeliverReportSummaryDetail = {
      key,
      id: key,
      label: key,
      value: summary[key],
      units,
    };
    return detail;
  });
};
